const toNonProd = new URLSearchParams(window.location.search).has('non-prod')

export const COVEO_ACCESS_TOKEN = toNonProd
    ? 'xxea192144-c340-457a-bfb0-dfb5cbe4970e'
    : 'xxc997e6c1-d94a-4d9f-b8fb-0c641f6813f3'
export const COVEO_ORGANIZATION_ID = toNonProd
    ? 'nespressononproduction1skusciyz'
    : 'nespressoproductiong3iqhhz5'
export const COVEO_PLATFORM_URL = 'https://platform-eu.cloud.coveo.com'
